import { jsxs, jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { forwardRef } from 'react';
import { getColor } from '../utils/color.mjs';
import useId from './hooks/useId.mjs';
import { getID, FlexLinearGradient } from './shared/FlexLinearGradient.mjs';

const VisibilityAltIcon = forwardRef(
  ({
    color: rawColor = "currentColor",
    size: sizeFromProps,
    type = "default",
    style,
    ...props
  }, forwardedRef) => {
    const { id } = useId();
    const isGradient = isPresetGradientColor(rawColor);
    const color = isGradient ? `url(#${getID(rawColor, id)})` : getColor(rawColor);
    const size = sizeFromProps ?? 24;
    if (type === "fill") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M16.973 7.336a8.98 8.98 0 0 0-4.992-1.39 8.995 8.995 0 0 0-4.956 1.375c-1.513.94-2.762 2.304-3.631 3.941a1 1 0 0 0 1.767.938c.713-1.345 1.724-2.438 2.919-3.18a6.994 6.994 0 0 1 3.877-1.073h.053a6.98 6.98 0 0 1 3.903 1.084c1.2.752 2.214 1.86 2.922 3.221a1 1 0 0 0 1.775-.923c-.863-1.658-2.115-3.041-3.637-3.993Z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M15.5 13.18a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
              }
            )
          ]
        }
      );
    }
    if (type === "default") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M16.973 7.336a8.98 8.98 0 0 0-4.992-1.39 8.995 8.995 0 0 0-4.956 1.375c-1.513.94-2.762 2.304-3.631 3.941a1 1 0 0 0 1.767.938c.713-1.345 1.724-2.438 2.919-3.18a6.994 6.994 0 0 1 3.877-1.073h.053a6.98 6.98 0 0 1 3.903 1.084c1.2.752 2.214 1.86 2.922 3.221a1 1 0 0 0 1.775-.923c-.863-1.658-2.115-3.041-3.637-3.993Z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M12 16.68a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.5-3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    console.error(
      `VisibilityAltIcon doesn't support the combination of ${size} and ${type}`
    );
    return null;
  }
);

export { VisibilityAltIcon };
//# sourceMappingURL=VisibilityAltIcon.mjs.map
